import React from 'react';
import { Task } from '../../../../../types/task';

interface TaskNotesDisplayProps {
  task: Task;
}

/**
 * 任务备注显示组件
 * 统一使用精致的带图标样式
 */
export const TaskNotesDisplay: React.FC<TaskNotesDisplayProps> = ({
  task
}) => {
  if (!task.notes) return null;

  return (
    <span className="truncate flex items-center">
      <svg className="w-3 h-3 mr-0.5 text-ios-gray3 dark:text-ios-dark-gray3 flex-shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 12H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9 16H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9 8H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      <span className="truncate">{task.notes}</span>
    </span>
  );
};
